import { AxiosError, AxiosInstance } from 'axios';

/**
 * Cloudflare Challenge Interceptor
 *
 * Detects Cloudflare managed challenges (403 with cf-mitigated: challenge header)
 * and redirects the user to /challenge to complete verification.
 * After completing the challenge, the user is redirected back to their original location.
 */

const CHALLENGE_REDIRECT_KEY = 'cloudflare_challenge_redirect';

export const attachCloudflareChallenge = (api: AxiosInstance) => {
  api.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
      // Check if this is a Cloudflare managed challenge
      if (
        error.response?.status === 403 &&
        error.response?.headers?.['cf-mitigated'] === 'challenge'
      ) {
        // Store the current location to redirect back after challenge
        const currentPath = window.location.pathname + window.location.search;
        sessionStorage.setItem(CHALLENGE_REDIRECT_KEY, currentPath);

        // Redirect to the challenge page
        const challengeUrl = `/challenge?redirTo=${encodeURIComponent(currentPath)}`;
        window.location.href = challengeUrl;

        // Return a rejected promise to stop further processing
        return Promise.reject(new Error('Redirecting to Cloudflare challenge'));
      }

      // Pass through other errors
      return Promise.reject(error);
    }
  );
};

/**
 * Get the stored redirect path after challenge completion
 */
export const getChallengeRedirectPath = (): string | null => {
  const path = sessionStorage.getItem(CHALLENGE_REDIRECT_KEY);
  if (path) {
    sessionStorage.removeItem(CHALLENGE_REDIRECT_KEY);
  }
  return path;
};